import React, { FC, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { LawyerCardProfile } from '../../../../../lawyer/card/LawyerCardProfile';
import { EntitiesCardBody } from '../../../../../components/entities-card/EntitiesCardBody';
import { EntitiesCardFooter } from '../../../../../components/entities-card/EntitiesCardFooter';
import { doctrineAnalytics } from '../../../../../utils/analyticsUtils';
import { Connect, PropsFromRedux } from './LawyerSnippetContainer';
import { ResultsType } from '../../../../state/reducers/results.types';
import { SnippetActions } from '../SnippetActions';
import { useRestrictedModal } from '../../../../../components/modal/useRestrictedModal';
import './lawyer_snippet.scss';
import { useUser } from '../../../../../user/useUser';
import { Paper } from '../../../../../components/paper/Paper';

type Props = {
  lawyer: NonNullable<ResultsType['snippets']['professional']>;
} & PropsFromRedux;

export const RawLawyerSnippet: FC<Props> = ({
  originalQueryKey,
  lawyer,
  isFilterToggled,
  toggleLawyerFilter,
}) => {
  const { accessPremium } = useUser();
  const { openRestrictedModal } = useRestrictedModal();

  useEffect(() => {
    doctrineAnalytics('Search ProfessionalDisplayed', {
      lawyer_id: lawyer.lawyerId,
      query_key: originalQueryKey,
    });
  }, []);

  const handleClick = (source: string) => () => {
    if (!accessPremium) {
      openRestrictedModal({ source });
    }
  };

  const onToggle = () => {
    const value = isFilterToggled ? undefined : lawyer.lawyerId;
    doctrineAnalytics('Search RestrictLawyerClicked', {
      lid: lawyer.lawyerId,
      restricted: !isFilterToggled,
    });

    toggleLawyerFilter(value);
  };

  return (
    <Paper className="lawyer-snippet">
      <EntitiesCardBody>
        <LawyerCardProfile
          lawyer={lawyer}
          onClick={handleClick('search-lawyer-snippet-header')}
          href={
            accessPremium
              ? `${lawyer.url}?source=search-lawyer-snippet-header`
              : undefined
          }
        />
      </EntitiesCardBody>
      <SnippetActions isToggled={isFilterToggled} onToggle={onToggle} />
      <EntitiesCardFooter
        onClick={handleClick('search-lawyer-snippet-footer')}
        href={
          accessPremium
            ? `${lawyer.url}?source=search-lawyer-snippet-footer`
            : undefined
        }
      >
        <FormattedMessage id="search/components/search-snippets/aside/lawyer/LawyerSnippet.tsx/1" />
      </EntitiesCardFooter>
    </Paper>
  );
};

export const LawyerSnippet = Connect(RawLawyerSnippet);
